import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState(15 * 60);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  return <div className="bg-[#F5A623] rounded-2xl p-6 md:p-8 text-center text-white max-w-md mx-auto border-2 border-[#E09520]" data-id="element-70">
      <h3 className="text-xl md:text-2xl font-extrabold mb-3 leading-tight" data-id="element-71">
        ¡OFERTA DE LANZAMIENTO!
      </h3>

      <p className="text-sm md:text-base mb-1" data-id="element-72">Esta Oferta Exclusiva Termina</p>
      <p className="text-sm md:text-base font-bold underline underline-offset-4 mb-3" data-id="element-73">
        HOY MARTES 10 DE FEBRERO
      </p>

      <p className="text-xs md:text-sm leading-relaxed mb-5 opacity-95" data-id="element-74">
        Tu lugar estará reservado durante{' '}
        <span className="font-bold underline underline-offset-2" data-id="element-75">
          15 minutos
        </span>
        , en caso de no acceder se cederá el descuento a la siguiente persona.
      </p>

      {/* Timer display */}
      <div className="flex items-baseline justify-center gap-1 mb-1" data-id="element-76">
        <span className="text-5xl md:text-6xl font-extrabold tracking-tight" data-id="element-77">
          {formatTime(minutes)}
        </span>
        <span className="text-4xl md:text-5xl font-extrabold" data-id="element-78">:</span>
        <span className="text-5xl md:text-6xl font-extrabold tracking-tight" data-id="element-79">
          {formatTime(seconds)}
        </span>
      </div>

      <div className="flex justify-center gap-10 text-[10px] md:text-xs font-semibold tracking-widest uppercase opacity-90" data-id="element-80">
        <span data-id="element-81">Minutos</span>
        <span data-id="element-82">Segundos</span>
      </div>
    </div>;
}